import { createSelector } from 'reselect';

const getSingleFamilyEnterprise = (state) => state.singleFamilyEnterprise;

const SingleFamilyEnterpriseSelectors = {
  makeContracts: createSelector(
    [getSingleFamilyEnterprise],
    (singleFamilyEnterprise) => singleFamilyEnterprise.contracts,
  ),
};

export default SingleFamilyEnterpriseSelectors;
